<template lang="pug">
AccountLayout(accountPageHeading="Manage account")
   ._mb4(v-if="loaded")
      template(slot="header-content")
         ._mt1._c-grey-500 Account created on {{ makerState && makerState.maker.data && makerState.maker.data.createdAt | defaultDateTime }}
      //- ----------------------------------------------------------------
      //- Teams
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Your teams")
         ._border._bg-white._boxShadow._radius._pb1-5(v-if="makerState && makerState.maker")
            ._overflowHidden(v-if="makerState.teamProfiles && makerState.teamProfiles.length")
               //- Team list
               router-link.TeamItem._block._borderBottom-default._borderColor-grey-200._py1-5(:to="`/${teamProfile.data.slug.current}/manage/`" v-for="teamProfile in makerState.teamProfiles" :key="teamProfile.ref.id") 
                  ._px1-5._mb1._bold
                     | {{teamProfile.teamResolved.data.name}} team, at {{teamProfile.companyResolved.data.name}}
                  ._flex._px1-5._fs-075
                     | Added {{teamProfile.teamResolved.data.createdAt | defaultDate}}
                  //- ._flex._px1-5._fs-075
                  //-    ._c-grey-600 Setup complete?
                  //-    ._ml1._bold._c-grey-700 {{teamProfile.teamResolved.data.isSetupComplete ? 'Yes' : 'No'}}
            ._mt1-5._px1-5
               ._mb1-5(v-if="!makerState || !makerState.teamProfiles || !makerState.teamProfiles.length") 
                  ._c-grey-500._ls-05 You have not yet added or joined a team.
               button.Btn.Btn--white.Btn--sm(type="button" @click="handleAddTeamClick()") 
                  ._flex._flex-alignItemsCenter
                     ._fs-3._mr1 +
                     div Add team
      //- ----------------------------------------------------------------
      //- User info
      //- ----------------------------------------------------------------
      ._mb3
         AccountPanelHeading(heading="Your info")
         ._border._bg-white._boxShadow._radius._pb2._relative(v-if="makerState && makerState.maker")
            div(v-if="!editMode")
               ._flex._px1-5._pt2._pb1
                  ._c-grey-700(style="width: 100px;") Name:
                  div(v-if="makerState.maker.data.name") {{makerState.maker.data.name}}
                  div._c-grey-400(v-else) Not set
               ._flex._px1-5._py1
                  ._c-grey-700(style="width: 100px;") Email:
                  ._flex._flex-alignItemsCenter
                     div {{makerState.maker.data.email}}
                     .Box-notice._flex._flex-alignItemsCenter._ml1._radius._px025._py025._fs-025(v-if="!makerState.maker.data.isEmailVerified") 
                        | Not verified!
                     .Box-green._flex._flex-alignItemsCenter._ml1._radius._px025._py025._fs-025(v-if="makerState.maker.data.isEmailVerified") 
                        | Verified
               ._flex._px1-5._py1
                  ._c-grey-700(style="width: 100px;") Password:
                  div *************
               ._mt1-5._px1-5
                  button.Btn.Btn--white.Btn--sm(type="button" v-on:click="editMode = true") Edit your info
            form._relative(v-if="editMode" @submit.prevent="handleSubmit")
               Loading(v-if="busy")
               div
                  label.Label._flex._flex-alignItemsCenter._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Name:
                     input.Input(type="text" v-model="userInfoFormState.name")
                  label.Label._flex._flex-alignItemsCenter._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Email:
                     ._w100
                        input.Input._mb025(type="text" v-model="userInfoFormState.email")
                        ._c-grey-400._fs-075 You will need to verify your email after changing it
                  label.Label._flex._flex-alignItemsCenter._pl2._pr075._pt075
                     .LabelText._mb0._c-grey-700(style="width: 200px") Password:
                     ._w100
                        input.Input._mb025(type="password" v-model="userInfoFormState.password" placeholder="enter new password")
                        ._c-grey-400._fs-075 Min length 6 characters
               ._mt2._px1-5
                  button.Btn.Btn--green._px3._mr1(type="submit") Save
                  button.Btn.Btn--white(type="button" v-on:click="editMode = false") Cancel
      //- ----------------------------------------------------------------
      //- Account info
      //- ----------------------------------------------------------------
      div(v-if="makerState && makerState.maker")
         AccountPanelHeading(heading="Account info")
         ._border._bg-white._boxShadow._radius._pb2
            ._flex._flex-alignItemsCenter._px1-5._pt1-5
               ._c-grey-600(style="width: 150px;") Created:
               ._bold._c-grey-700 {{makerState.maker.data.createdAt | defaultDateTime}}
            ._flex._flex-alignItemsCenter._px1-5._pt1-5
               ._c-grey-600(style="width: 150px;") Last updated:
               ._bold._c-grey-700 {{makerState.maker.ts | defaultDateTime}}
</template>

<style lang="sass" scoped>
.Icon svg
   width: 24px
   display: inherit
.TeamItem
   text-decoration: none
   color: $grey-700
   &:hover,
   &:focus
      background-color: $grey-050
      color: $grey-800
</style>

<script>
import { mapState } from 'vuex'
import AccountLayout from '~/layouts/MakerAdmin.vue'
import AccountPanelHeading from '~/components/AccountPanelHeading.vue'

export default {
   components: {
      AccountLayout,
      AccountPanelHeading,
   },
   data() {
      return {
         loaded: false,
         busy: false,
         userInfoFormState: {
            // name: this.$store.maker.maker.data.name,
            // email: this.$store.maker.maker.data.email,
            name: null,
            email: null,
            password: null,
         },
         errors: {
            name: null,
            email: null,
            password: null,
            general: false,
         },
         editMode: false,
      }
   },
   computed: {
      ...mapState(['makerState']),
   },
   metaInfo() {
      return {
         title: `test`,
         meta: [
            {
               key: 'description',
               name: `description`,
               content: `View openings with the world's best remote-friendly companies. Find a job with a remote team that exceeds your expectations (so you can exceed theirs).`,
            },
         ],
      }
   },
   methods: {
      // ...mapActions(['logOut']),
      showEditMode() {
         this.userInfoFormState.password = null // ensure password is null (it's set to something if they've just changed it)
         this.editMode = true
      },
      checkForm() {
         if (this.userInfoFormState.name && this.userInfoFormState.email) {
            this.errors.name = null
            this.errors.email = null
            this.errors.password = null
            this.errors.general = null
            return true
         }
      },
      confirmIfEmailOrPasswordChange(payload) {
         // Since email and password are used for login,
         // ensure the user is aware that they will have to use these new credentials
         // next time they log in.
         var message
         // updating email and password
         if (payload.email && payload.password) {
            message =
               "You're about to update both your email and password, which are each used to sign in to your account. This means you'll need to use these updated credentials the next time you sign in. Do you want to continue?"
         }
         // updating email
         else if (payload.email) {
            message =
               "You're about to update your email, which is use to sign in to your account. This means you'll need to use this updated email the next time you sign in. Do you want to continue?"
         }
         // updating password
         else {
            message =
               "You're about to update your password, which is use to sign in to your account. This means you'll need to use this updated password the next time you sign in. Do you want to continue?"
         }

         return this.$swal({
            title: 'Please confirm',
            text: message,
            icon: 'warning',
            buttons: true,
         })
      },
      handleAddTeamClick() {
         // If the user is only a member of 1 company, default the new team to that company.
         // Note: The company can be toggled in the new team flow, this simply seems the expected UX.
         if (this.makerState && this.makerState.companies && this.makerState.companies.length === 1) {
            const data = {
               company: {
                  ref: this.makerState.companies[0].ref,
               },
            }
            return this.$store.dispatch('updateNewTeamTempState', data).then(() => {
               this.$nextTick(() => this.$router.push('/add-team/step-2'))
            })
         } else {
            return this.$router.push('/add-team/step-1')
         }
      },
      handleSubmit() {
         // TODO: Need to validate email and password here, just like on the new account form
         // TODO: Need to consider a more secure approach to resetting email and password...
         //       Currently, just having access to the account allows changing either (without knowing the current pw or having access to the current email)...
         //       Consdier:
         //          - require the current password for email/pw change
         //          - require email confirmation for email/pw change

         this.busy = true
         if (!this.checkForm()) {
            this.busy = false
            return
         }

         var payload = {}
         if (this.userInfoFormState.name !== this.makerState.maker.data.name) {
            payload.name = this.userInfoFormState.name
         }
         if (this.userInfoFormState.email !== this.makerState.maker.data.email) {
            payload.email = this.userInfoFormState.email
         }
         if (this.userInfoFormState.password) {
            payload.password = this.userInfoFormState.password
         }

         if (payload.email || payload.password) {
            this.confirmIfEmailOrPasswordChange(payload).then(shouldContinue => {
               if (!shouldContinue) {
                  this.editMode = false
                  this.busy = false
               } else {
                  this.submitUpdate(payload)
               }
            })
         } else {
            this.submitUpdate(payload)
         }
      },
      submitUpdate(payload) {
         return this.$store
            .dispatch('updateUserInfo', payload)
            .then(() => {
               this.$snotify.success('User info updated')
            })
            .catch(() => {
               this.errors.general = true
            })
            .finally(() => {
               this.editMode = false
               this.busy = false
            })
      },
   },
   mounted() {
      this.loaded = true
      console.log('here!: ', this.makerState)
   },
}
</script>
